import * as React from 'react';
import { Banner } from '@/components/ui/banner';
import type { InstitutionWarning } from '../types';

interface WarningAlertProps {
  warning: InstitutionWarning;
}

export const WarningAlert: React.FC<WarningAlertProps> = ({ warning }) => (
  <Banner
    tone={warning.type === 'missing-docs' ? 'critical' : 'caution'}
    title={warning.message}
  />
);
